import dayjs from 'dayjs'
import { Controller } from 'libraries/front-end-core/core/Router'
import getUrl from 'libraries/front-end-core/core/url'
import { CURRENT_AWARENESS } from 'constants/controllers'
import { DATE_FORMAT } from 'constants/locale'
import NotFound from 'components/NotFound'
import CaHeaderContainer from 'redux/containers/pages/currentawareness/CaHeaderContainer'
import CurrentAwarenessMainContainer from 'redux/containers/pages/currentawareness/CurrentAwarenessMainContainer'
import Left from './Left'

export default new Controller({
  name: CURRENT_AWARENESS,
  route: 'news(/:aol)/archive(/browse/:fromDate/:toDate)(/id/:id)',
  controller (
    Router,
    { url, scrollMain, pageView, pageData, params },
    render
  ) {
    const { id = null, aol } = params
    let {
      fromDate = dayjs().subtract(3, 'days').format(DATE_FORMAT),
      toDate = dayjs().format(DATE_FORMAT)
    } = params
    const pageId = id ? url : getUrl(CURRENT_AWARENESS, { aol })

    fromDate = dayjs(fromDate).format(DATE_FORMAT)
    toDate = dayjs(toDate).format(DATE_FORMAT)
    if (toDate < fromDate) {
      render({ Main: NotFound }, {}, { aol })
      return url
    }

    render(
      {
        Header: CaHeaderContainer,
        Main: CurrentAwarenessMainContainer,
        Left
      },
      { fromDate, toDate, aol, id },
      {
        aol,
        pageId,
        searchType: 'ca',
        className: 'ca',
        pageView,
        feedbackOptions: ['ca']
      }
    )

    return pageId
  }
})
